<template>
  <view class="list-content" wx:class="{{ bottomBarClass }}" wx:style="{{customStyle}}">
    <view wx:if="{{priceDetailCardTip}}" class="fee-info-warn">
      <image
        class="warn-icon"
        src="https://dpubstatic.udache.com/static/dpubimg/cxFbrFo8rY23sNI4pJzRg.png"
      />
      <text class="warn-copywritting">{{priceDetailCardTip}}</text>
    </view>
    <view
      class="fee-container"
      wx:for="{{formatFeeInfo}}"
      wx:if="{{formatFeeInfo && Object.keys(formatFeeInfo).length}}"
    >
      <view class="fee-info-title" wx:if="{{item.title}}">
        <view class="fee-info-item" bindtap="goPage(item)">
          <view class="fee-info-item-title">{{ item.title }}</view>
          <view class="rich-text-bold" wx:style="color:{{item.color}}"
            >¥{{ item.price / 100 }}
            <es-icon
              name="angle-right"
              color="#999999"
              size="16"
              wx:if="{{item.show_arrow}}"
            />
          </view>
        </view>
        <view class="fee-info-item-tip-left">{{ item.left_tip }}</view>
        <view class="fee-info-item">
          <view class="fee-info-item-tip-left">{{ item.create_time }}</view>
          <view class="fee-info-item-tip-right">
            {{ item.right_tip }}
          </view>
        </view>
      </view>
      <view
        class="content-bg"
        wx:class="{{ item?.fee_item?.length > 1 && 'muti-row'}}"
        wx:if="{{item.fee_item && item.fee_item.length > 0 }}"
      >
        <block wx:for="{{item.fee_item}}" wx:for-item="fee">
          <view class="fee-content-item">
            <view
              class="fee-content-item-left"
              wx:style="color:{{fee.color}};fontWeight:{{fee.bold ? 'bold' :''}};fontSize:{{fee.pixel}}">
              <image wx:if="{{fee.icon}}" class="icon" src="{{fee.icon}}" />
              <view>{{ fee.name }}</view>
            </view>
            <view
              class="{{fee.value && fee.name && fee.bold && !fee.notLine ? 'fee-info line' : 'fee-info'}}"
            ></view>
            <view class="fee-content-item-right" wx:style="color:{{fee.valueColor}}">
              <view class="appointment-tag" wx:if="{{fee.type && fee.type === '学生票'}}">约</view>
              {{ fee.value }}
            </view>
          </view>
        </block>
      </view>
    </view>
    <view wx:if="{{studentLength > 0}}" class="student-tip">学生票面金额为预估价，最终以实际占座成功为准。</view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { getFinalPrice } from '@/utils/money'
  import { TrainFeeType } from '@/common/enum'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    props: {
      hasBottomBar: {
        type: Boolean,
        value: false,
      },
      priceDetail: {},
      customStyle: {},
      priceDetailCardTip:{
        type: String,
        value: '',
      },//卧铺标识
      studentLength: 0,
    },
    computed: {
      refactorFeeInfo() {
        return this.priceDetail?.fee_info?.map(item => {
          if(!item) return {}
          item.show_arrow =
            item.type == TrainFeeType.change || item.type == TrainFeeType.refund
          return item
        })
      },
      formatFeeInfo() {
        return this.refactorFeeInfo?.flat(Infinity) || []
      },
      totalPrice() {
        return getFinalPrice(this.totalInfo?.total_price) || 0
      },
      bottomBarClass() {
        return {
          'list-content-bottom-margin': this.hasBottomBar,
          'list-content-no-bottom': !this.hasBottomBar,
        }
      },
    },
    data: {},
    watch: {
      show: {
        immediate: true,
        deep: true,
        handler(old) {
          if (this.show) {
            this.priceDetail?.map?.((item, index) => {
              //第一条不展示
              item.showDetailButton = item?.tip !== '' && index !== 0
              return item
            })
          }
        },
      },
    },
    methods: {
      closePriceDetail() {
        this.$trigger('close', null)
      },
      hideDetailButton(pos) {
        this.priceDetail?.map?.((item, index) => {
          if (pos === index) {
            item.showDetailButton = false
          }
          return item
        })
        this.$forceUpdate()
      },
      goPage(item) {
        this.closePriceDetail()
        switch (item.type) {
          case TrainFeeType.refund:
            this.toRefundPage(item)
            break
          case TrainFeeType.change:
            this.toChangePage(item)
            break
          default:
            break
        }
      },
      toRefundPage(item) {
        innerRouter.push(pagePath().REFUNDTICKETDETAILPAGE, {
          order_id: item.order_id,
          selected_ticket_id: item?.ticket_id,
          from: this.from,
        })
      },
      toChangePage(item) {
        innerRouter.push(pagePath().CHANGETICKETDETAILPAGE, {
          order_id: item.order_id,
          selected_ticket_id: item?.ticket_id,
          from: this.from,
        })
      },
    },
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .main, .list-content
    background-color #ffffff
    border-radius 8px
    display flex
    flex-direction column
    &-bottom-margin
      margin 0 12px 100px 12px
    &-no-bottom
      margin 0 12px 33px 12px
    .fee-container:last-child
      margin-bottom 30px
    .student-tip
      font-size 11px
      color #999999
      text-align center
  .fee-info-warn
    margin-bottom 16px
    margin-left 4px
    display flex
    align-items center
  .warn-icon
    height 10px
    width 10px
    flex none
    margin-right 2px
  .warn-copywritting
    font-size 12px
    line-height 12px
    letter-spacing 0px
    color #666666
  .fee-info-title
    margin 5px 12px 12px
  .fee-info
    margin 0px 10px
    width 100%
    margin-top 10px
    &.line
      border-top 1px dashed #cccccc
  .fee-content-item
    display flex
    align-items flex-start
    padding-top 16px
    &-left
      color $train-color-999
      font-size 14px
      white-space nowrap
      display flex
      align-items center
      .icon
        width 16px
        height 16px
        margin-right 4px
    &-right
      color #666
      font-family PingFangSC-Regular
      font-size 14px
      line-height 20px
      white-space nowrap
      display flex
      .appointment-tag
        margin-right 4px
    .red-color
      color #FF4343
  .content-bg
    background #F6F9FD
    border-radius 10px
    padding 0px 12px 16px
    margin-bottom 8px
    &.muti-row
      background #eaf3ff
	    box-sizing border-box
	    border 0.5px solid #8fc8e9
    &:not(:last-child)
      margin-bottom 8px
  .fee-info-item-title
    color $train-color-333
    font-size 15px
    font-weight 500
    font-family PingFangSC
    // white-space nowrap
  .divider
    height 1px
    border-top 1px solid rgba(0, 0, 0, 0.04)
    text-align center
  .fee-info-item
    display flex
    justify-content space-between
    align-items flex-start
    &-tip-left
      color $train-color-999
      font-size 12px
    &-tip-right
      display flex
      color $train-color-theme-blue
      font-size 12px
      line-height 12px
  .rich-text-bold
    font-family PingFangSC-Semibold
    font-size 18px
    letter-spacing 0
    text-align right
    display flex
    align-items center
    color $train-color-theme-blue
    font-weight normal
</style>


<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {},
  }
</script>